import React, { useMemo } from 'react'

import { API_URL } from '../constants'

import { useItems } from '../../hooks'

import FormField, { FIELD_TYPES } from '../../components/FormField'

const AILayerSelectList = ({
  field: { label, name, defaultValue },
  item,
  onChange,
}) => {
  const [{ response: aiLayers, isLoading, error }] = useItems(API_URL)

  const field = useMemo(() => {
    if (isLoading || error || !aiLayers) return null
    return {
      type: FIELD_TYPES.SELECT,
      label: label || 'AI Layer',
      name,
      defaultValue,
      options: aiLayers.map((p) => ({
        label: p.name,
        value: p.id,
      })),
    }
  }, [name, label, defaultValue, aiLayers, isLoading, error])

  if (field === null)
    return (
      <div>
        <label>{label}</label>
        <div>
          Loading AI Layers... <i className="fa fa-spinner fa-spin"></i>
        </div>
      </div>
    )

  return <FormField field={field} item={item} onChange={onChange} />
}

export default AILayerSelectList
